import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-scroll';
import './naviBar.css'
function Header() {
    return (
        <>
            <Navbar className='naviBar'>
                <Container>
                    <Navbar.Brand href="#home">AniMe</Navbar.Brand>
                    <Nav className="me-auto">
                        <Nav.Link href="#home">
                            <Link
                                to="videoComponent" // або "descriptionComponent" залежно від потрібного компонента
                                smooth={true}
                                duration={500}
                            >
                                Дивитись
                            </Link>
                        </Nav.Link>
                        <Nav.Link href="#features">
                            <Link
                                to="comments" // або "descriptionComponent" залежно від потрібного компонента
                                smooth={true}
                                duration={500}
                            >
                                Коментарі
                            </Link>
                        </Nav.Link>
                        <Nav.Link href="#pricing">
                            <Link
                                to="footer" // або "descriptionComponent" залежно від потрібного компонента
                                smooth={true}
                                duration={500}
                            >
                                Коментарі
                            </Link>
                        </Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
        </>
    );
}

export default Header;
